import React from "react";
import styled from "styled-components";

const Container = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 3rem;
  margin-bottom: 5px;
  cursor: pointer;
  color: ${props => props.theme.colors.text};
  font-size: 1.1rem;
  user-select: none;
  
  div {
   line-height: 1.5rem;
  }
  a {
    font-weight: 700;
  }
  
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  & input:checked ~ .checkmark {
    border: 1px solid ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary};
  }
  & input:checked ~ .checkmark:after {
    display: block;
  }
`;

const CheckMark = styled.span`
  position: absolute;
  top: 2px;
  left: 0;
  height: 1.6rem;
  width: 1.6rem;
  background-color: transparent;
  border-radius: 2px;
  border: 1px solid #c9c9c9;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 1rem;
    border: solid white;
    border-width: 0 1px 1px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const Checkbox = ({label, name, value, handleChange}) => {
  return (
      <Container>
        <div dangerouslySetInnerHTML={{__html: label}}/>
        <input type="checkbox"
               name={name}
               value={value}
               checked={value ? 'checked' : ''}
               onChange={handleChange}/>
        <CheckMark className={`checkmark`}/>
      </Container>
  )
};

export default Checkbox;